import React from 'react';
import type { Tab } from '@/features/dashboard/types/dashboard.types';

interface DashboardTabBarProps {
    tabs: Tab[];
    activeTabId: string;
    currentUserType: string;
    isMaintenance: boolean;
    getPageLabel: (page: string) => string;
    onTabClick: (tabId: string) => void;
    onCloseTab: (tabId: string, e?: React.MouseEvent) => void;
    onCloseAllTabs: () => void;
}

const DashboardTabBar: React.FC<DashboardTabBarProps> = ({
                                                             tabs,
                                                             activeTabId,
                                                             currentUserType,
                                                             isMaintenance,
                                                             getPageLabel,
                                                             onTabClick,
                                                             onCloseTab,
                                                             onCloseAllTabs,
                                                         }) => (
    <div className="tabs-container">
        <div className="tabs-header">
            {tabs.map((tab) => {
                const isTabDisabled =
                    currentUserType === 'SUPPLIER' &&
                    isMaintenance &&
                    tab.page !== 'dashboard';

                return (
                    <div
                        key={tab.id}
                        className={`tab ${activeTabId === tab.id ? 'active' : ''} ${isTabDisabled ? 'disabled' : ''}`}
                        onClick={() => {
                            if (isTabDisabled) return;
                            onTabClick(tab.id);
                        }}
                        style={isTabDisabled ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
                    >
                        <span className="tab-label">{getPageLabel(tab.page)}</span>
                        {tab.id !== 'dashboard' && (
                            <button
                                className="tab-close"
                                onClick={(e) => {
                                    if (isTabDisabled) {
                                        e.stopPropagation();
                                        return;
                                    }
                                    onCloseTab(tab.id, e);
                                }}
                                disabled={isTabDisabled}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        )}
                    </div>
                );
            })}
            {tabs.length > 1 && (
                <button className="close-all-tabs-btn" onClick={onCloseAllTabs}>
                    <i className="fas fa-times-circle"></i>
                    <span>전체 닫기</span>
                </button>
            )}
        </div>
    </div>
);

export default DashboardTabBar;
